export default "__VITE_ASSET__f2dfb396__"